export const environment = {
    production: true,
    server: "http://sonobee.southeastasia.cloudapp.azure.com/api"
};



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts